import React from 'react';

import { Box } from '@mui/material';
import Spinner from '@provider-portal/common/components/Spinner/Spinner';

const styles = { width: '100%', height: '100%' };

export interface FullViewSpinnerProps {
  size?: string;
}

const FullViewSpinner: React.FC<FullViewSpinnerProps> = ({ size }) => {
  return (
    <Box display="flex" alignItems="center" justifyContent="center" sx={styles}>
      <Spinner size={size} />
    </Box>
  );
};

export default FullViewSpinner;
